import { Footer } from "../sections/footer/footer";
import { Header } from "../sections/header/header";
import styles from "./AboutUsPage.module.css";
import HenkProfilePicture from "../../shared/assets/Henk-Profile.jpg";
import MattanjaProfilePicture from "../../shared/assets/Mattanja-Profile.jpg";
import AnneMarieProfilePicture from "../../shared/assets/Anne-Marie-Profile.jpg";

export const AboutUsPage = () => (
  <div>
    <Header />
    <div className={styles.container}>
      <div className={styles.desktopLayout}>
        {/* Left Column - Text Sections */}
        <div className={styles.leftColumn}>
          {/* Wie we niet zijn section */}
          <section className={`${styles.section} ${styles.whoWeAreNot}`}>
            <div className={styles.sectionContent}>
              <div className={styles.textContent}>
                <h2 className={styles.sectionTitle}>Wie we niet zijn</h2>
                <p className={styles.sectionText}>
                  We zijn geen hulpverleners. Ben je op zoek naar ondersteuning? Misschien kan Humanitas (
                  <a href="https://www.humanitas.nl/noord-veluwe/" className={styles.link}>
                    https://www.humanitas.nl/noord-veluwe/
                  </a>
                  ) je op weg helpen. Wil je eens laagdrempelig praten met iemand over verlies? Kijk dan ook eens bij
                  Luisterend Oor (
                  <a href="https://luisterendoorharderwijk.nl/" className={styles.link}>
                    https://luisterendoorharderwijk.nl/
                  </a>
                  ).
                </p>
                <p className={styles.sectionText}>
                  Mocht je meer ondersteuning nodig hebben, dan kun je kijken of maatschappelijk werk iets voor je is. Het is
                  gratis en laagdrempelig. Zie{" "}
                  <a href="https://stimenz.nl/harderwijk" className={styles.link}>
                    https://stimenz.nl/harderwijk
                  </a>{" "}
                  voor meer info.
                </p>
                <p className={styles.sectionText}>
                  Als je twijfelt of je hulp nodig hebt, dan kun je altijd bij je huisarts terecht. Als het nodig is kan die
                  je verwijzen naar passende hulp.
                </p>
                <p className={styles.sectionText}>
                  We zijn geen penvrienden. Natuurlijk mag je vaker dan een keer je hart luchten bij opluchtpost. Maar: we
                  gaan er bij elke brief vanuit dat de uitwisseling eenmalig is. Ook kunnen we niet beloven dat een tweede
                  brief bij dezelfde lezer uitkomt.
                </p>
              </div>
            </div>
          </section>

          {/* Wie we wel zijn section */}
          <section className={`${styles.section} ${styles.whoWeAre}`}>
            <div className={styles.sectionContent}>
              <div className={styles.textContent}>
                <h2 className={styles.sectionTitle}>Wie we wel zijn</h2>
                <p className={styles.sectionText}>
                  Henk Ruiter en Mattanja Hoenderdos zijn initiatiefnemers van Opluchtpost. Wij zijn twee inwoners van
                  Harderwijk met enerzijds een liefde voor taal en schrijven, en anderzijds een drive om onze stad een klein
                  stukje mooier te maken.
                </p>
                <p className={styles.sectionText}>
                  Opluchtpost is geïnspireerd op het vergelijkbare project 'De Huisbus' in Gent. We wilden graag zoiets
                  mogelijk maken voor Harderwijk. Henk is tussen 2019-2022 stadsdichter geweest van Harderwijk. Mattanja
                  heeft ook affiniteit met poëzie en vanuit dit gedeelde enthousiasme is Opluchtpost ontstaan.
                </p>
              </div>
            </div>
          </section>
        </div>

        {/* Right Column - Profile Sections */}
        <div className={styles.rightColumn}>
          {/* Henk Profile section */}
          <section className={`${styles.section} ${styles.henkProfile}`}>
            <div className={styles.sectionContent}>
              <div className={styles.profileContainer}>
                <div className={styles.profileSection}>
                  <img src={HenkProfilePicture} alt="Henk Ruiter" className={styles.profileImage} />
                  <div className={styles.profileInfo}>
                    <h3 className={styles.profileName}>Henk Ruiter</h3>
                    <p className={styles.profileDescription}>
                      Ik ben Henk en ik woon sinds 15 jaar in Harderwijk. Elke keer als ik Harderwijk inrijd of -fiets,
                      ervaar ik een gevoel van thuiskomen. Ik woon in een heerlijk huis in de binnenstad.
                      Kunst en poëzie zijn voor mij troostend en geven verdieping aan het leven. Dagen je geest uit om anders
                      te kijken en te denken. Een van mijn favoriete citaten is van Gerrit Krol: 'Als je niet elke dag met
                      een stok in je ziel roert, dan vries je dicht.' Ik denk dat kunst daarin een belangrijke rol kan
                      spelen. Kunst en poëzie delen met anderen is nog mooier, schrijf daarom een brief!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Mattanja Profile section */}
          <section className={`${styles.section} ${styles.mattanjaProfile}`}>
            <div className={styles.sectionContent}>
              <div className={styles.profileContainer}>
                <div className={styles.profileSection}>
                  <img src={MattanjaProfilePicture} alt="Mattanja Hoenderdos" className={styles.profileImage} />
                  <div className={styles.profileInfo}>
                    <h3 className={styles.profileName}>Mattanja Hoenderdos</h3>
                    <p className={styles.profileDescription}>
                      Ik ben Mattanja, een van de gezichten achter Opluchtpost. Ik woon mijn hele leven al in Harderwijk en
                      kan me ook geen andere plek inbeelden om te wonen. Ik hou van het water, het bos, de zandverstuiving en
                      de heide en alles is hier om de hoek. Ik woon samen met Marco en onze zoon Lukas in een rijtjeshuis
                      waarin nooit meer dan 1 kamer opgeruimd is en een kat rondloopt alsof hij de baas is. Ik hou van kunst
                      en poëzie omdat ze de wereld kunnen vangen op een manier dat groter voelt, dat een kern raakt die je in
                      je dagelijkse communicatie niet snel tegenkomt. Het kan je raken, overvallen, je chaos op zijn plek
                      laten vallen of gewoon heel hard laten lachen. Een van mijn favoriete gedichten is 'de wonderen' van
                      Han G. Hoekstra, omdat het vertelt dat wie goed kijkt, kan ontdekken dat er zoveel te verwonderen is.
                      Leuk dat je meeleest, ik deel graag meer mooie gedichten. Stuur je ons een brief?
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Anne Marie Profile section */}
          <section className={`${styles.section} ${styles.anneMarieProfile}`}>
            <div className={styles.sectionContent}>
              <div className={styles.profileContainer}>
                <div className={styles.profileSection}>
                  <img src={AnneMarieProfilePicture} alt="Anne Marie Goudkuil" className={styles.profileImage} />
                  <div className={styles.profileInfo}>
                    <h3 className={styles.profileName}>Anne Marie Goudkuil</h3>
                    <p className={styles.profileDescription}>
                      Ik ben Anne Marie, woon in Harderwijk met man en een kat en ik heb drie dochters die elders wonen.
                      Sinds september 2026 ben ik aangehaakt bij Opluchtpost. Opluchtpost is een geweldig initiatief van
                      Mattanja en Henk. Dat ik voor dit doel mijn interesse in poëzie, literatuur en schrijven kwijt kan,
                      vind ik keigaaf. Opluchtpost geeft je de gelegenheid je hart te luchten, even stil te staan om dat wat
                      je dwars zit, of dat wat je raakt te delen met een willekeurige ander. Je bericht wordt gelezen, niet
                      alleen geliked, maar er wordt over nagedacht en er wordt een zorgvuldig antwoord geschreven als je dat
                      wilt ontvangen. Ik zou graag willen dat we allemaal wat liever worden voor elkaar, want zoals Babs
                      Gons zegt: Alles wat je liefhebt, wordt mooi. Poëzie verzacht de mens, kunst verzacht de wereld.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <Footer />
  </div>
);
